import { State } from '../../types';

export const nebraska: State = {
  name: 'Nebraska',
  abbreviation: 'NE',
  terms: [
    {
      word: 'Beatrice',
      phonetic: 'bee-AT-riss',
      // audioUrl: '/audio/beatrice.mp3',
      description: 'A city in Gage County, often mispronounced as "BEE-uh-triss."'
    },
    {
      word: 'Kearney',
      phonetic: 'CAR-nee',
      // audioUrl: '/audio/kearney.mp3',
      description: 'A city in Buffalo County, pronounced differently from its spelling.'
    },
    {
      word: 'Norfolk',
      phonetic: 'NOR-fork',
      // audioUrl: '/audio/norfolk.mp3',
      description: 'A city in Madison County, pronounced as "NOR-fork" instead of "NOR-folk."'
    },
    {
      word: 'Hooper',
      phonetic: 'HOO-pur',
      // audioUrl: '/audio/hooper.mp3',
      description: 'A city in Dodge County, pronounced with a short "oo" sound.'
    },
    {
      word: 'Tekamah',
      phonetic: 'teh-KAY-muh',
      // audioUrl: '/audio/tekamah.mp3',
      description: 'A city in Burt County, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Steinauer',
      phonetic: 'STEEN-ow-er',
      // audioUrl: '/audio/steinauer.mp3',
      description: 'A village in Pawnee County, pronounced as "STEEN-ow-er" instead of "STINE-ow-er."'
    },
    {
      word: 'Omaha',
      phonetic: 'OH-muh-haw',
      // audioUrl: '/audio/omaha.mp3',
      description: 'The largest city in Nebraska, sometimes mispronounced as "OH-ma-ha."'
    },
    {
      word: 'Papillion',
      phonetic: 'puh-PILL-yun',
      // audioUrl: '/audio/papillion.mp3',
      description: 'A city in Sarpy County, pronounced as "puh-PILL-yun" instead of "puh-PILL-ee-on."'
    },
    {
      word: 'Wahoo',
      phonetic: 'WAH-hoo',
      // audioUrl: '/audio/wahoo.mp3',
      description: 'A city in Saunders County, pronounced as "WAH-hoo" instead of "WAY-hoo."'
    },
    {
      word: 'Weeping Water',
      phonetic: 'WEE-ping WAW-ter',
      // audioUrl: '/audio/weeping_water.mp3',
      description: 'A city in Cass County, sometimes mispronounced as "WEEP-ing WAH-ter."'
    }
  ]
};